import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Evanescence extends Bloc {

	constructor (src, ctx, target) {

		super("evanescence", src, ctx, true);
		this.types = [];
		this.out = [this, null];
		this.trigger = (src, image) => this.execute({src, image, trigger: this});
	}

	execute (props) {
		
		props = props || {};
		props.trace = props.trace || [];
		props.trace.push(this);
		this.out = [this, this.data];
		if (this.to)
			this.to.execute(props);
	}

	setup (owner, image) {

		let run = owner.master.run ? owner.master.run : owner.master;
		if (!run.broadcaster)
			return;

		var that = this;
		owner.evanescence = () => that.trigger(owner, image);
		owner.innereffects = owner.innereffects || [];
		owner.innereffects.push(this);
	}
}